import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useConfiguration } from "../hooks/useConfiguration";
import { STEPS } from "../lib/steps";
import { ContactsStep } from "./ContactsStep";
import { CoveragePathStep } from "./CoveragePathStep";
import { DefaultsStep } from "./DefaultsStep";
import { FinishStep } from "./FinishStep";
import { NotificationsStep } from "./NotificationsStep";
import { RequestsStep } from "./RequestsStep";
import { StaffTimingStep } from "./StaffTimingStep";
import { StepFooter } from "./StepFooter";
import { StepNav } from "./StepNav";
import { Surface } from "./Surface";
import { VoiceStep } from "./VoiceStep";

export function WizardLayout() {
  const { stepIndex } = useConfiguration();
  const step = STEPS[stepIndex];

  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      spacing={2.5}
      sx={{ alignItems: "flex-start" }}
    >
      <StepNav />
      <Surface sx={{ flex: 1, width: "100%" }}>
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: "0.75rem",
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            color: "text.secondary",
            mb: 0.75,
          }}
        >
          Step {stepIndex + 1} of {STEPS.length}
        </Typography>
        <Typography sx={{ fontWeight: 700, fontSize: "1.35rem", mb: 0.5 }}>
          {step.title}
        </Typography>
        <Typography sx={{ color: "text.secondary", mb: 2.5 }}>
          {step.blurb}
        </Typography>
        {step.id === "channels" ? <NotificationsStep /> : null}
        {step.id === "policy" ? <CoveragePathStep /> : null}
        {step.id === "tiers" ? <StaffTimingStep /> : null}
        {step.id === "notify" ? <ContactsStep /> : null}
        {step.id === "types" ? <RequestsStep /> : null}
        {step.id === "tenant" ? <DefaultsStep /> : null}
        {step.id === "agent" ? <VoiceStep /> : null}
        {step.id === "review" ? <FinishStep /> : null}
        <StepFooter />
      </Surface>
    </Stack>
  );
}
